import {useState} from "react";
import '../../styles/Common.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretRight} from "@fortawesome/free-solid-svg-icons/faCaretRight";
import {faCaretDown} from "@fortawesome/free-solid-svg-icons";

/**
 *
 * @param title
 * @param children {JSX.Element} content to display when tab is expanded
 * @returns {JSX.Element}
 * @constructor
 */
export default function ExpandableTab({title, children}){
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleTab = () => {
        setIsExpanded((ie) => !ie);
    };

    return (
        <div className="expandable-tab-container">
            <div className="expandable-tab-container-header" onClick={toggleTab}>
                <h5>
                    {(isExpanded) ? (
                        <FontAwesomeIcon icon={faCaretDown} />
                    ) : (
                        <FontAwesomeIcon icon={faCaretRight} />
                    )}
                    &nbsp;
                    {title}
                </h5>
            </div>

            {isExpanded && (
                <div className="expandable-tab-container-content">
                    {children}
                </div>
            )}
        </div>
    );
};